import React, { useEffect, useState } from 'react';
import { Hook, Unhook } from 'console-feed';
import HttpSink from './structure-log-http-sink';

const structuredLog = require('structured-log');

const LoggingContext = React.createContext();

/**
 * To use the Logger throughout the application. Do following
 *
 * import LoggingContext from CrLogger;
 * import useContext from 'react';
 *
 * and declare constant in the component where Logger is equired as follow
 *    const Log = useContext(LoggingContext)
 * and to use it simply call Log.error() or Log.warn() etc.
 */

/**
 * @param {LoggingMethos can be an array of ['error','warn','debug'} LoggingMethos
 * @returns LoggingProvider
 */
const LoggingProvider = ({ loggingMethods = [ 'error' ], children }) => {
  const [ logMessage, setLogMesssage ] = useState({});
  const [ Logger, setLogger ] = useState();
  // run once!
  useEffect(() => {
    Hook(
      window.console,
      (log) => {
        if (!!log && loggingMethods.includes(log.method)) {
          setLogMesssage(log);
        }
      },
      false
    );
    // one off
    setLogger(structuredLog.configure().writeTo(new HttpSink()).create());
    return () => Unhook(window.console);
  }, [ loggingMethods ]);

  useEffect(() => {
    if (!logMessage) return;

    switch (logMessage.method) {
      case 'fatal':
      {
        Logger.fatal(logMessage.data);
        break;
      }
      case 'error': {
        Logger.error(logMessage);
        break;
      }
      case 'warn': {
        Logger.warn(logMessage.data);
        break;
      }
      case 'information':
      {
        Logger.info(logMessage.data);
        break;
      }
      case 'debug': {
        Logger.debug(logMessage.data);
        break;
      }
      case 'verbose':
      {
        Logger.verbose(logMessage.data);
        break;
      }
      default: {
        // Do nothing
      }
    }
  }, [ logMessage, Logger ]);

  return (
    <LoggingContext.Provider value={Logger}>{children}</LoggingContext.Provider>
  );
};

export { LoggingProvider, LoggingContext };
